
import { defineComponent, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import PaymentAdminApi from '@/core/services/payment/PaymentAdminApi'
import { usePaginatedList } from '@/core/composables/usePaginatedList'
import { formatDateTime, formatMoney } from '@/core/helpers/paymentFormat'
import {
  incidentReasonLabels,
  incidentResolutionLabels,
  toOptions,
} from '@/core/services/payment/labels'
import { Incident, IncidentResolution } from '@/core/services/payment/types'
import PaymentListLayout from '@/core/components/payment/PaymentListLayout.vue'
import NewTabLink from '@/core/components/payment/NewTabLink.vue'
import PaymentFormDialog from '@/core/components/payment/PaymentFormDialog.vue'
import { FormField } from '@/core/components/payment/formField'

/**
 * Очередь платежей, которые система не смогла обработать сама.
 * «Платёж принят» возвращает заказ в paid и выдаёт услуги; остальные решения только фиксируют итог
 * (деньги при возврате возвращают вручную в кабинете ЮKassa).
 */
export default defineComponent({
  name: 'IncidentsList',
  components: { PaymentListLayout, PaymentFormDialog, NewTabLink },
  setup() {
    const list = usePaginatedList<Incident>(PaymentAdminApi.incidents.list, {
      defaults: { status: 'open', reason: '' },
    })
    const current = ref<Incident | null>(null)
    const resolveOpen = ref(false)

    const resolveFields: FormField[] = [
      {
        key: 'resolution',
        label: 'Решение',
        type: 'select',
        required: true,
        options: toOptions(incidentResolutionLabels),
      },
      {
        key: 'note',
        label: 'Комментарий',
        type: 'textarea',
        required: values => values.resolution !== 'accepted_manually',
        hint: 'Обязателен для возврата и «не требуется».',
      },
    ]

    const openResolve = (row: Incident) => {
      current.value = row
      resolveOpen.value = true
    }
    const resolveAction = (payload: Record<string, any>) =>
      PaymentAdminApi.incidents.resolve(
        (current.value as Incident).id,
        payload.resolution as IncidentResolution,
        payload.note
      )
    const onResolved = () => {
      ElMessage({ type: 'success', message: 'Инцидент закрыт' })
      list.load()
    }

    onMounted(list.init)

    return {
      ...list,
      resolveOpen,
      resolveFields,
      openResolve,
      resolveAction,
      onResolved,
      reasonOptions: toOptions(incidentReasonLabels),
      reasonLabels: incidentReasonLabels,
      resolutionLabels: incidentResolutionLabels,
      money: formatMoney,
      dateTime: formatDateTime,
    }
  },
})
